import { render, staticRenderFns } from "./ResetPasswordResult.vue?vue&type=template&id=13af7a54&scoped=true&"
import script from "./ResetPasswordResult.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordResult.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordResult.vue?vue&type=style&index=0&id=13af7a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13af7a54",
  null
  
)

export default component.exports